<template>
  <div class="px-10 my-5 flex">
    <div class="pr-10 mr-10 border-r-2 border-gray-400">
      <div>
        <div v-for="(item, i) in kPrivate" :key="i" class="mb-4">
          <button
            @click="onPressBtnLabel(item)"
            class="w-full mr-4 py-2 text-left px-4"
            :class="
              $route.path.includes(item.path) ? 'text-white bg-blue-700' : ''
            "
          >
            {{ item.btnLabel }}
          </button>
        </div>
      </div>
      <div v-if="my_userid == 1 || my_userid != 1">
        <div v-for="(item, i) in kPublic" :key="i" class="mb-4">
          <button
            @click="onPressBtnLabel(item)"
            class="w-full mr-4 py-2 text-left px-4"
            :class="
              $route.path.includes(item.path) ? 'text-white bg-blue-700' : ''
            "
          >
            {{ item.btnLabel }}
          </button>
        </div>
      </div>
    </div>
    <div class="w-full">
      <router-view />
    </div>
  </div>
</template>
<script>
import SecureStorage from "../../utils/secureStorage";

export default {
  data() {
    return {
      my_userid: null,
      kPrivate: [
        {
          btnLabel: "Users",
          path: "/home/settings/users",
          name: "Settings-Users",
        },
        {
          btnLabel: "Departments",
          path: "/home/settings/departments",
          name: "Settings-Departments",
        },
        {
          btnLabel: "Customers",
          path: "/home/settings/customers",
          name: "Customers",
        },
      ],
      kPublic: [
        {
          btnLabel: "Faq Settings",
          path: "/home/settings/faq",
          name: "Settings-FAQ",
        },
        {
          btnLabel: "CSV Uploader",
          path: "/home/settings/csv",
          name: "Settings-CSV-Uploader",
        },

        {
          btnLabel: "Email Match",
          path: "/home/settings/emailMatch",
          name: "Email Match",
        },
        //{
        //  btnLabel: "Update Contract Numbers",
        //  path: "/home/settings/update-contract-number",
        //  name: "Update Contract Numbers",
        //},

        // {
        //   btnLabel: "CSV",
        //   id: 2,
        //   path: "/home/settings/csv",
        //   name: "Settings-CSV",
        // },
        // {
        //   btnLabel: "CSV email duplicate validator",
        //   id: 2,
        //   path: "/home/settings/csv-validator",
        //   name: "Settings-CSV-VALIDATOR",
        // },
      ],
    };
  },
  mounted() {
    this.getUserId();
  },
  methods: {
    getUserId() {
      this.my_userid = SecureStorage.getItem("auth").userId;
    },
    onPressBtnLabel(item) {
      if (!this.$route.path.includes(item.path)) {
        this.$router.push({
          name: item.name,
          query: {
            cc: this.$route.query.cc,
            cn: this.$route.query.cn,
          },
        });
      }
    },
  },
};
</script>
